import {AppError} from "../core/AppError";
import {actionUserLogout} from "../store/global";

export class BaseService {

	static processResponse(response: any): Promise<any> {

		return new Promise((resolve, reject) => {
			if (!response) reject(BaseService.unknownError)
			if (!response.status) reject(BaseService.setAppError(response))
			if (response.status == 401) {
				reject(BaseService.setAppError(response))
			}
			if (response.status != 200) reject(BaseService.setAppError(response))
			if (!response.data) reject(BaseService.setAppError(response))
			if (!response.data.data) reject(BaseService.setAppError(response))
			if (response.data.errorId) reject(BaseService.setAppError(response))
			if (response.status == 409 )reject(BaseService.setAppError(response))
			resolve (response.data.data)
		})
	}

	static setAppError(data: any): AppError {

		let error: AppError = {
			id: 0,
			code: data.status,
			message: 'Unknown error',
			response: data
		}
		if (data.response) {
			if (data.response.data) {
				error.message = data.response.data.message
				error.id = data.response.data.errorId
			}
		}

		return error
	}

	static unknownError: AppError = {
		id: 0,
		code: 0,
		message: 'Unknown error'
	}
	
}